// extracted by mini-css-extract-plugin
export var dataCell = "_lt-2";
export var dataRow = "_lt-0";
export var headerRow = "_lt-1";